import { useContext, useEffect, useState } from "react";

import { EventsStateContext } from "../../../../../../../../context/EventsProvider";

//For monitoring calls on the when follow up modal is open
export const useFollowUpCallLogger = () => {
  const globalEventState = useContext(EventsStateContext);
  const [isActivelyCalling, setIsActivelyCalling] = useState(false);
  const [followUpId, setFollowUpId] = useState(null);
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    let active = true;
    console.log("use effect start");

    const removeIds = () => {
      setSessionId(null);
      setFollowUpId(null);
    };
    const addCallListener = (e) => {
      const data = e.data;
      switch (data.type) {
        case "rc-active-call-notify":
          // active call event
          if (!isActivelyCalling) {
            if (data?.call?.sessionId) {
              if (globalEventState?.callSystem?.followUpId) {
                setSessionId(data?.call?.sessionId);
                setFollowUpId(globalEventState?.callSystem?.followUpId);
              }
            }
          }

          break;
        case "end-call":
          // end call event
          setIsActivelyCalling(false);
          setSessionId(null);
          setFollowUpId(null);
          break;
        default:
          break;
      }
    };

    if (active) {
      window.addEventListener("message", addCallListener);
    }

    return () => {
      //when component unmounts make sure listener is removed
      active = false;
      window.removeEventListener("message", removeIds);
    };
  }, []);
  return {
    followUpId,
    sessionId,
    isActivelyCalling,
  };
};
